// ink-component
import React from 'react';
import styled from 'styled-components';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { shimmerBase, shimmerRoll } from '../../_common/styles';
import { CSSWidthType, CSSHeightType } from '../../../../helpers/constants/cssPropTypes';

export interface ShimmerRectangleProps {
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
  /** The width of the shimmer component measured in css length values.
   * For the circle variant, the width prop controls both width and height. */
  width?: CSSWidthType;
  /** The height of the shimmer component measured in css length values. */
  height?: CSSHeightType;
}

const StyledShimmer = styled.div`
  ${shimmerBase};
  animation-name: ${props => shimmerRoll(props.theme.width)};
  height: ${({ theme }) => theme.height};
  width: ${props => props.theme.width};
`;

const globalProps = getGlobalProps({});

/**
 * @purpose Rectangular shimmer to indicate data is loading
 * @group shimmer
 */
const ShimmerRectangle = (props: ShimmerRectangleProps) => {
  // @ts-ignore
  const { className, style, width, height } = props;

  const shimmerProps = {
    ...globalProps,
    'data-testid': props['data-testid'],
    className: 'ink-shimmer shimmer__variant-rectangle',
  };

  const theme = {
    width,
    height,
  };

  return (
    <StyledShimmer theme={theme} {...shimmerProps}>
      &nbsp;
    </StyledShimmer>
  );
};

ShimmerRectangle.defaultProps = {
  'data-testid': undefined,
  width: '100%',
  height: 'initial',
};

ShimmerRectangle.displayName = 'Shimmer.Rectangle';

export default ShimmerRectangle;
